export const FormatListBulleted = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 7H30" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<circle cx="7" cy="7" r="2" fill="currentColor"/>
<path d="M12 25H30" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<circle cx="7" cy="25" r="2" fill="currentColor"/>
<path d="M12 16H30" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<circle cx="7" cy="16" r="2" fill="currentColor"/>
</svg>`;
